import { FileUploadActionField } from 'schemaBuilder/types';
import { test as validate, enforce } from 'vest';

export default (field: FileUploadActionField, fieldPath: string) => {
  validate(
    `${fieldPath}.schemaField.label`,
    `Please fill the required fields`,
    () => {
      enforce(field.schemaField.label).isNotEmpty();
    }
  );
};
